import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'
import {
  EMPTY_TO_ONE,
  EMPTY_TO_MANY,
  linkageFromResource,
} from '@opallabs/json-api'
import { userResourceFactory } from './user'
import { workspaceResourceFactory } from './workspace'

type CategoryTypeResourceV3 = OpalApiComponent<'V3', 'category_type'>

export const categoryTypeResourceFactory: Factory<CategoryTypeResourceV3> =
  Factory.define<CategoryTypeResourceV3>(({ sequence }) => {
    return {
      id: uuidV4(),
      type: 'category_type',
      attributes: {
        name: `Mock Category Type ${sequence}`,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        description: null,
        deactivated_at: null,
        supported_paired_type: null,
      },
      relationships: {
        creator: linkageFromResource(userResourceFactory.build()),
        custom_fields: EMPTY_TO_MANY,
        workspace: linkageFromResource(workspaceResourceFactory.build()),
        default_child_type: EMPTY_TO_ONE,
        in_support_of_category_types: EMPTY_TO_MANY,
      },
    } satisfies CategoryTypeResourceV3
  })
